import React from "react";

function StoryMute() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
    >
      <g
        id="Audio_Off_Icon"
        data-name="Audio Off Icon"
        transform="translate(-1107 -134)"
      >
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="18.5"
          cy="18.5"
          r="18.5"
          transform="translate(1107 134)"
          opacity="0.7"
        />
        <g
          id="Icon_akar-sound-off"
          data-name="Icon akar-sound-off"
          transform="translate(1113.327 139.162)"
        >
          <path
            id="Path_19898"
            data-name="Path 19898"
            d="M29.5,19,24,13.5m5.5,0L24,19"
            transform="translate(-8.158 -2.913)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            id="Path_19899"
            data-name="Path 19899"
            d="M3,16.053v-5.43a.937.937,0,0,1,.917-.954H7.207a.9.9,0,0,0,.649-.28l2.752-3.108a.913.913,0,0,1,1.566.675V19.72a.913.913,0,0,1-1.574.666L7.856,17.3a.9.9,0,0,0-.657-.288H3.917A.937.937,0,0,1,3,16.053Z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default StoryMute;
